import { render, staticRenderFns } from "./SaveView.vue?vue&type=template&id=6bf4edfc&"
import script from "./SaveView.vue?vue&type=script&lang=js&"
export * from "./SaveView.vue?vue&type=script&lang=js&"
import style0 from "./SaveView.vue?vue&type=style&index=0&id=6bf4edfc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports